import { getAccessToken } from 'api/authentication/utils/getAccessToken';
import { fetchWithToken } from 'api/fetcher';
import { type OutputOperationResult } from 'api/types';
import overrides from 'app/config/config.overrides.json';
import { isLocalDev } from 'utils/env';
import { transform } from 'utils/values';

import { type FeatureFlagNames, featureFlagNamesSet } from './features/FeatureFlagConfigurationSetting';
import type { AppConfiguration } from './types';

export const CONFIG_BASE_URL = isLocalDev ? overrides.ConnectionStringsAppConfiguration : '/public_config';

export const fetchConfiguration = async (): Promise<OutputOperationResult<AppConfiguration>> => {
  const response = await fetchWithToken<string[]>(CONFIG_BASE_URL, getAccessToken());
  return transform(response, (names) => ({
    features: names.filter((name): name is FeatureFlagNames => featureFlagNamesSet.has(name))
  }));
};
